import { createSlice } from '@reduxjs/toolkit';
import { ProviderTransferCompanyDetailStateType } from '../../types/providerTransferCompanyDetail';

const initialState: ProviderTransferCompanyDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const providerTransferCompanyDetailSlice = createSlice({
    name: 'providerTransferCompanyDetail',
    initialState,
    reducers: {
        getProviderTransferCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProviderTransferCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getProviderTransferCompanyDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createProviderTransferCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createProviderTransferCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createProviderTransferCompanyDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateProviderTransferCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateProviderTransferCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateProviderTransferCompanyDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        deleteProviderTransferCompanyFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteProviderTransferCompanyFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteProviderTransferCompanyFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProviderTransferCompanyDetail: () => initialState,
    },
});

export const {
    getProviderTransferCompanyDetailFetch,
    getProviderTransferCompanyDetailFetchSuccess,
    getProviderTransferCompanyDetailFetchFailure,
    createProviderTransferCompanyDetailFetch,
    createProviderTransferCompanyDetailFetchSuccess,
    createProviderTransferCompanyDetailFetchFailure,
    updateProviderTransferCompanyDetailFetch,
    updateProviderTransferCompanyDetailFetchSuccess,
    updateProviderTransferCompanyDetailFetchFailure,
    deleteProviderTransferCompanyFetch,
    deleteProviderTransferCompanyFetchSuccess,
    deleteProviderTransferCompanyFetchFailure,
    clearProviderTransferCompanyDetail,
} = providerTransferCompanyDetailSlice.actions;

export default providerTransferCompanyDetailSlice.reducer;
